import { Link } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面未找到-布丁漫画网',
    description: '您访问的页面不存在，请返回布丁漫画网首页继续阅读漫画。',
    keywords: '布丁漫画网,404,漫画,在线免费阅读',
    path: '/404',
  });

  return (
    <div className="relative flex flex-col items-center justify-center overflow-hidden px-4 py-24 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none text-[10rem] font-black text-background-200 md:text-[14rem]">
        404
      </h1>
      <div className="relative z-10">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-4 py-1.5 text-xs text-primary-700">
          <i className="ri-map-pin-time-line"></i>
          你好像迷路了
        </span>
        <h1 className="mt-5 text-2xl text-foreground-950 md:text-3xl">
          这个页面不存在
        </h1>
        <p className="mt-3 text-sm text-foreground-600 md:text-base">
          页面可能已被移动或删除，去看看其他精彩漫画吧
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-6 py-2.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50 sm:w-auto"
          >
            浏览全部漫画
          </Link>
        </div>
      </div>
    </div>
  );
}